import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SalesStageDetails = () => {
  const { stageId } = useParams();
  const decodedId = stageId ? atob(stageId) : stageId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES.salesStage}${id}/` : null;
  const { data: stage, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!stage) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(stage)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [stage]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.salesStage}${id}/`);
      showToast('Sales stage deleted successfully', 'success');
      navigate('/customer/sales-stage/list');
    } catch (error) {
      console.error('Error deleting sales stage:', error);
      showToast('Failed to delete sales stage', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={stage}
        columns={columns}
        loading={loading}
        entityName="Sales Stage"
        listPath="/customer/sales-stage/list"
        editPath={`/customer/sales-stage/input/${btoa(stageId)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Sales Stage"
        message="Are you sure you want to delete this sales stage?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SalesStageDetails;
